import { createTheme } from '@mui/material/styles';

export const getColor = (name, shade = 400) => {
	// TODO: Support shade names (lighter = 100, light = 300, regular = 400, bold = 700, heavy = 900)
	// TODO: Support intermediate shade values (if there's no shade match, blend the two nearest by the shade provided)
	if (name === 'white' && typeof colors.white === 'string')return colors.white; // This is a patch because the colors.white is being overwritten
	return colors[name][shade];
};

export const remCalc = (px, base = 16) => {
	const tempPx = `${px}`.replace('px', '')

	return (1 / base) * parseInt(tempPx) + 'rem'
}

export const globalTransitionDuration = '0.25s';

export const dateFormat = {
	year: '2-digit',
	month: 'numeric',
	day: 'numeric',
};

let theme = createTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 640,
			md: 1024,
			lg: 1180,
			xl: 1458
		}
	},
});

// Color Palette Update Changes -> 8

// Blue
// 1. primary 500 (#0F2345) -> Blue 700 (Oxford Blue) -> Theme.js ✅ -> Repo ✅
// 2. primary 400 (#174A87) -> Blue 500 (Polynesian Blue) -> Theme.js ✅ -> Repo ✅
// 3. secondary 200 (#A8DEEF) -> Blue 200 (Non Photo Blue) -> Theme.js ✅ -> N/A in Repo ✅

// Gray
// 4. primary 300 (#7799A8) -> Gray 600 (Cadet Gray) -> Theme.js ✅ -> Repo ✅

// Red
// 5. accent1 200 (#F05644) -> Red 500 (Tomato) -> Theme.js ✅ -> Repo ✅

// Yellow
// 6. accent1 100 (#FFCE64) -> Yellow 600 (Sunglow) -> Theme.js ✅ -> Repo ✅

// No Matches
// 7. secondary 300 (#4C7FBE) -> proposed change: Blue 300 -> Theme.js ✅ -> N/A in Repo ✅
// 8. secondary 100 (#F3E3D1) -> proposed change: Khaki 700 -> Theme.js ✅ -> N/A in Repo ✅

export const colors = {
	primary: {
		500: '#0F2345', // Blue 700
		400: '#174A87', // Blue 500
		300: '#7799A8', // Gray 600
	},
	secondary: {
		300: '#4C7FBE', // No Direct Match in new palette
		200: '#A8DEEF', // Blue 200
		100: '#F3E3D1', // No Direct Match in new palette
	},
	accent1: {
		200: '#F05644', // Red 500
		100: '#FFCE64', // Yellow 600
	},
	white: {
		100: '#FFFFFF',
	},
	blue: {
		700: '#0F2345',
		600: '#045172',
		500: '#174A87',
		400: '#23799E',
		300: '#348EB2',
		200: '#A8DEEF',
		100: '#B7E0EA',
	},
	gray: {
		700: '#979797',
		600: '#7799A8',
		500: '#BCCCD0',
	},
	khaki: {
		700: '#EDD9C3',
	},
	red: {
		700: '#A41D13',
		600: '#EF3426',
		500: '#F05644',
	},
	yellow: {
		700: '#FFBD52',
		600: '#FFCE64',
	}
};
colors.white = getColor('white', 100);
colors.black = '#000000';

export const typography = {
	typography: {
		htmlFontSize: 10,
		fontSize: 16,
		fontFamily: [
			'Open Sans',
			'sans-serif',
		].join(', '),
		// Headers
		h1: {
			color: colors.white,
			fontSize: remCalc(30),
			lineHeight: 1.06,
			textTransform: 'none',
			fontWeight: 600,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(48),
				lineHeight: 1.08,
			},
			//Doesn't work :(
			//variants: [
			//	{
			//		props: { variant: 'large' },
			//		style: {
			//			fontSize: remCalc(40),
			//			lineHeight: 1.15,
			//			[theme.breakpoints.up('md')]: {
			//				fontSize: remCalc(75),
			//				lineHeight: 1.06,
			//			}
			//		}
			//	}
			//],
		},
		h1MastheadTitle: {
			fontSize: remCalc(40),
			lineHeight: 1.15,
			fontWeight: 600,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(65),
				lineHeight: 1.06,
			}
		},
		h1__404: {
			color: colors.white,
			fontSize: remCalc(40),
			lineHeight: remCalc(46),
			marginBottom: remCalc(9),
			textTransform: 'none',
			fontWeight: 600,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(96),
				lineHeight: remCalc(75),
				marginBottom: remCalc(30),
			},
		},
		h2: {
			color: colors.white,
			fontSize: remCalc(28),
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			lineHeight: 1.07,
			textTransform: 'none',
			fontWeight: 600,
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(40),
				lineHeight: 1.15,
			},
		},
		h2CardTitle: {
			color: colors.white,
			fontSize: remCalc(28),
			lineHeight: 1.07,
			textTransform: 'none',
			fontWeight: 400,
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(40),
                lineHeight: 1.15,
            },
		},
		h2Result: {
			color: colors.white,
			margin: 0,
			fontSize: remCalc(64),
			lineHeight: .83,
			textTransform: 'none',
			fontWeight: 600,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
		},
		h3: {
			color: colors.white,
			fontSize: remCalc(28),
			lineHeight: 1.07,
			textTransform: 'none',
			fontWeight: 600,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(36),
				lineHeight: 1.11,
			},
			//variants: [
			//	{
			//		props: { variant: 'card' },
			//		style: {
			//			fontWeight: 400,
			//			fontFamily: [
			//				'din-2014',
			//				'sans-serif',
			//			].join(', '),
			//		}
			//	}
			//]
		},
		h3__card: {
			color: colors.white,
			fontSize: remCalc(28),
			lineHeight: 1.07,
			textTransform: 'none',
			fontWeight: 600,
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(36),
                lineHeight: 1.11,
            },
		},
		h4: {
			color: colors.white,
			fontSize: remCalc(24),
			lineHeight: 1.16,
			textTransform: 'none',
			fontWeight: 600,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			variants: [
				{
					props: { variant: 'card' },
					style: {
						fontWeight: 400,
						fontFamily: [
							'din-2014',
							'sans-serif',
						].join(', '),
					}
				}
			]
		},
		h5: {
			color: colors.white,
			fontSize: remCalc(20),
			lineHeight: 1.2,
			textTransform: 'none',
			fontWeight: 400,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
		},
		h6: {
			color: colors.white,
			fontSize: remCalc(18),
			lineHeight: 1.33,
			textTransform: 'none',
			fontWeight: 400,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
		},
		// Body
		body1: {
			color: colors.white,
			fontSize: remCalc(16),
			lineHeight: 1.25,
			fontWeight: 400,
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(20),
				lineHeight: 1.2,
			},
			a: {
				color: colors.white,
                textDecoration: 'underline',
				transition: `all ${globalTransitionDuration} linear`,
				'&:not(.MuiButton-root):hover': {
					color: getColor('yellow', 600),
				}
			}
		},
		body1Masthead: {
			color: colors.white,
            fontSize: remCalc(20),
            lineHeight: 1.4,
            fontWeight: 400,
            [theme.breakpoints.up('md')]: {
                fontSize: remCalc(24),
                lineHeight: 1.16,
            }
		},
		body1MastheadSmall: {
			color: colors.white,
            fontSize: remCalc(16),
            lineHeight: 1.25,
            fontWeight: 400,
			[theme.breakpoints.up('md')]: {
                fontSize: remCalc(20),
                lineHeight: 1.2,
            }
		},
		body1ResultSubject: {
			color: colors.white,
			fontSize: remCalc(28),
			lineHeight: 1.64,
			fontWeight: 600,
			marginBottom: remCalc(14),
			
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(36),
                lineHeight: 1.27,
				fontWeight: 600,
				marginBottom: remCalc(20),
            }
		},
		body1ResultCopy: {
			color: colors.white,
			fontSize: remCalc(16),
			lineHeight: 1.25,
			fontWeight: 400,
			fontFamily: [
				'open-sans',
				'sans-serif',
			].join(', '),
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(20),
				lineHeight: 1.20,
			}
		},
		// Generated by Copilot
		body2: {
			color: colors.white,
			fontSize: remCalc(14),
			lineHeight: 1.5,
			fontWeight: 400,
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(18),
				lineHeight: 1.25,
			}
		},
		// End
		p__card__date: {
			fontSize: remCalc(14),
			lineHeight: 1.5,
			fontWeight: 400,
			fontStyle: 'italic',
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(18),
				lineHeight: 1.875,
			}
		},
		p__card: {
			fontSize: remCalc(16),
            lineHeight: 1.25,
            fontWeight: 400,
			[theme.breakpoints.up('md')]: {
                fontSize: remCalc(20),
                lineHeight: 1.2,
				'&.staffCard__tenure': {
					fontSize: '1rem',
				}
            },
		},
		p__blog__post__masthead__date: {
			fontSize: remCalc(16),
            lineHeight: 1.25,
            fontWeight: 400,
            fontStyle: 'italic',
			[theme.breakpoints.up('md')]: {
                fontSize: remCalc(20),
                lineHeight: 1.2,
            }
		},
		p__blog__post__masthead__backLink: {
			fontSize: remCalc(16),
            lineHeight: 1.25,
            fontWeight: 400,
            color: colors.white,
            textDecoration: 'none',
            marginBottom: '80px',
			[theme.breakpoints.up('md')]: {
                fontSize: remCalc(20),
                lineHeight: 1.2,
            },
            'a': {
            	color: colors.white,
				'.back__arrow': {
	            	transform: 'rotate(90deg) translateX(10px)',
	            },
            }
		},
		nav: {
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(16),
			lineHeight: 1,
			fontWeight: 600,
			textTransform: 'uppercase',
			[theme.breakpoints.up('md')]: {
				fontSize: remCalc(20),
			},
		},
		mobileNav: {
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(30),
			color: getColor('white', 100),
			lineHeight: 1,
			fontWeight: 600,
			textTransform: 'uppercase',
		},
		footerLinkParent: {
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(20),
			fontWeight: 600,
			lineHeight: 1,
			textTransform: 'uppercase',
		},
		footerLinkChild: {
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(16),
			fontWeight: 600,
			lineHeight: 1,
		},
		footerLocation: {
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(25),
			fontWeight: 600,
			lineHeight: 1.25,
		},
		copyright: {
			fontFamily: [
				'open-sans',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(16),
			fontWeight: 600,
			color: getColor('gray', 600),
		},
		awardsTitle: {
			color: colors.white,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(40),
			fontStyle: "normal",
			fontWeight: 600,
			lineHeight: "46px",
			textTransform: "none",
			[theme.breakpoints.down('md')]: {
				fontSize: remCalc(30),
                lineHeight: "53px",
            },
		},
		awardsText: {
			color: colors.white,
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(24),
			fontStyle: "normal",
			fontWeight: 600,
			lineHeight: "34px",
			textTransform: "none",
			[theme.breakpoints.down('md')]: {
				fontSize: remCalc(20),
            },
		},
		formTitle: {
			color: colors.white,
			fontFamily: [
				'franklin-gothic-atf',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(48),
			fontStyle: "normal",
			fontWeight: 600,
			lineHeight: "46px",
			marginBottom: "2rem",
			textTransform: "none",
			[theme.breakpoints.down('md')]: {
				fontSize: remCalc(30),
                lineHeight: "53px",
            },
		},
		formText: {
			color: colors.white,
			fontFamily: [
				'open-sans',
				'sans-serif',
			].join(', '),
			fontSize: "1.25rem",
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "24px",
			marginBottom: "4rem",
			textTransform: "none",
			[theme.breakpoints.down('md')]: {
				fontSize: remCalc(16),
                lineHeight: "20px",
            },
		},
		staffCategories: {
			color: colors.white,
			fontFamily: [
				'din-2014',
				'sans-serif',
			].join(', '),
			fontSize: remCalc(24),
			fontStyle: "normal",
			fontWeight: 600,
			lineHeight: "38px",
			textTransform: "none",
		},
	},	
}

theme = createTheme({
	...typography,
});

export default theme;